import axios from 'axios';

import type { CountryCode } from '@hotjar/country-lib';
import { mapConfigDTOtoModel } from '../mapper';
import type { PaymentDetailsConfig } from '../types';

const BASE_URL_PATH = '/api/checkout/payment-pages/configuration';

export const api = {
  getConfigurationsFromCountryCode: (countryCode: CountryCode): Promise<PaymentDetailsConfig[]> =>
    axios
      .get(`${BASE_URL_PATH}/${countryCode}`)
      .then((res) => res.data)
      .then(({ configurations }) => configurations.map(mapConfigDTOtoModel)),
  getConfigurationsFromCustomerId: (customerId: number): Promise<PaymentDetailsConfig[]> =>
    axios
      .get(`${BASE_URL_PATH}/customers/${customerId}`)
      .then((res) => res.data)
      .then(({ configurations }) => configurations.map(mapConfigDTOtoModel)),
};
